/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Tab_Header1Inputs */

const vi_sitesettings_tab_header1 = /** @type {(inputs: Sitesettings_Tab_Header1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đầu trang`)
};

/**

* @param {Sitesettings_Tab_Header1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_tab_header1 = /** @type {((inputs?: Sitesettings_Tab_Header1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Tab_Header1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_tab_header1(inputs)
});
export { sitesettings_tab_header1 as "siteSettings_tab_header" }